export const outreachKeys = {
  all: ["autoleads", "outreach"] as const,
  state: (campaignId: number) =>
    [...outreachKeys.all, "state", campaignId] as const,
  syncStats: (campaignId: number) =>
    [...outreachKeys.all, "sync-stats", campaignId] as const,
  rounds: (campaignId: number) =>
    [...outreachKeys.all, "rounds", campaignId] as const,
  syncPreview: (campaignId: number) =>
    [...outreachKeys.all, "sync-preview", campaignId] as const,
}
